if (window.location.hash === '#top') {
	if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}

	const scrollToTop = () => window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

	scrollToTop();
	requestAnimationFrame(scrollToTop);
	window.addEventListener('load', scrollToTop, { once: true });
}

window.addEventListener('DOMContentLoaded', function () {

	// Fixed header scroll state + case study mega panel top (viewport-fixed strip)
	const header = document.querySelector('.header--seevogel');
	const mega = document.querySelector('.js-case-study-mega');

	// Case study mega links deep-link to #case-N on the case study page. Clicked from
	// that same page it's a same-document hash change, so the link keeps focus and
	// :focus-within holds the panel open even after the pointer leaves. Drop focus so
	// the panel closes on mouse-out (issue #91).
	if (mega) {
		mega.addEventListener('click', (event) => {
			const link = event.target.closest('a');
			if (link) {
				requestAnimationFrame(() => link.blur());
			}
		});
	}
	if (header) {
		let headerTicking = false;
		const updateHeader = () => {
			headerTicking = false;
			const isScrolled = window.scrollY > 10;
			header.classList.toggle('is-scrolled', isScrolled);
			if (mega) {
				const r = header.getBoundingClientRect();
				// Pull panel up slightly so it overlaps the header strip — avoids a dead
				// zone between the link and the menu where :hover leaves the <li> and closes it.
				const bridgePx = 16;
				mega.style.setProperty('--case-study-mega-top', `${Math.round(r.bottom) - bridgePx}px`);
			}
		};
		const scheduleHeaderUpdate = () => {
			if (headerTicking) return;
			headerTicking = true;
			requestAnimationFrame(updateHeader);
		};
		window.addEventListener('scroll', scheduleHeaderUpdate, { passive: true });
		window.addEventListener('resize', scheduleHeaderUpdate, { passive: true });
		scheduleHeaderUpdate();

		const syncDarkHeroHeader = (entries) => {
			const entry = entries[0];
			const overHero = entry?.isIntersecting && entry.intersectionRatio > 0.08;
			header.classList.toggle('is-over-dark-hero', overHero);
		};
		const darkHeroObserver = new IntersectionObserver(syncDarkHeroHeader, {
			root: null,
			threshold: [0, 0.08, 0.2],
			rootMargin: '-80px 0px 0px 0px',
		});
		document.querySelectorAll('.intro--blog, .intro--article, .page-404__hero').forEach((hero) => {
			darkHeroObserver.observe(hero);
		});
	}

	// Scroll down button
	const scrollDownBtn = document.querySelector('.js-intro-scroll');
	if (scrollDownBtn) {
		scrollDownBtn.addEventListener('click', () => {
			window.scrollBy({ top: window.innerHeight, behavior: 'smooth' });
		});
	}

	document.querySelectorAll('.js-footer-back-top').forEach((btn) => {
		btn.addEventListener('click', () => {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		});
	});

	//mobile nav
	const burger = document.querySelector('.js-burger');
	const body = document.querySelector('body');
	const overlay = document.querySelector('.box-overlay');
	const navMobile = document.querySelector('.js-nav');

	if (burger && overlay && navMobile) {
		const syncBurgerState = (isOpen) => {
			burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		};

		burger.addEventListener('click', function () {
			this.classList.toggle('is-active');
			navMobile.classList.toggle('is-active');
			overlay.classList.toggle('is-active');
			body.classList.toggle('menu-show');
			syncBurgerState(this.classList.contains('is-active'));
		});

		overlay.addEventListener('click', function () {
			this.classList.toggle('is-active');
			navMobile.classList.toggle('is-active');
			burger.classList.toggle('is-active');
			body.classList.toggle('menu-show');
			syncBurgerState(false);
		});

		// Mobile drawer: the Case Studies panel/submenu is collapsed by default;
		// tapping its chevron link toggles it (desktop keeps its hover behaviour).
		const mobileMega = window.matchMedia('(max-width: 1200px)');
		navMobile.querySelectorAll('.nav__item--has-submenu > .nav__link--seevogel-chevron').forEach((link) => {
			const item = link.closest('.nav__item--has-submenu');
			link.setAttribute('aria-expanded', 'false');
			link.addEventListener('click', (event) => {
				if (!mobileMega.matches) return; // desktop: let hover + navigation work
				event.preventDefault();
				const open = item.classList.toggle('is-open');
				link.setAttribute('aria-expanded', open ? 'true' : 'false');
			});
		});
	}

});

/*
 * #140 / #156: smooth in-page anchor scrolling for touch devices.
 *
 * `html { scroll-behavior: smooth }` gives that for free, but on iOS Safari it
 * breaks native momentum scrolling (the inertia coast stops dead when you lift
 * your finger), so global.scss now limits it to `(pointer: fine)`. A one-off
 * programmatic smooth scroll has no such side effect, so do it in JS where the
 * CSS property is switched off.
 */
window.addEventListener('DOMContentLoaded', function () {
	if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return; // CSS already handles it

	document.addEventListener('click', (event) => {
		const link = event.target.closest('a[href*="#"]');
		if (!link || link.target === '_blank') return;

		const url = new URL(link.href, window.location.href);
		// Same-document links only, and only ones pointing at a real element.
		if (url.pathname !== window.location.pathname || url.search !== window.location.search) return;
		const id = url.hash.slice(1);
		if (!id) return; // bare "#" / "#0" toggles are not navigation
		const target = document.getElementById(id);
		if (!target) return;

		event.preventDefault();
		const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
		history.pushState(null, '', url.hash);
	});
});
